type MediaStorageKeys = {
  search: string;
  sortOptionId: number;
};

const defaultValues: MediaStorageKeys = {
  search: '',
  sortOptionId: 1,
};

export class mediaStorage {
  static getValues = () => {
    const mediaListStorage = localStorage.getItem('mediaList');
    if (mediaListStorage) {
      try {
        return JSON.parse(mediaListStorage);
      } catch (e) {
        console.log(e);
        return defaultValues;
      }
    }
    return defaultValues;
  };

  static setValue = <K extends keyof MediaStorageKeys>(key:K, value:MediaStorageKeys[K]) => {
    const mediaListStorage = mediaStorage.getValues();
    mediaListStorage[key] = value;
    localStorage.setItem('mediaList', JSON.stringify(mediaListStorage));
  };
}
